import { useQueryClient } from "@tanstack/react-query";
import { useProtectTRPC } from "../trpc";
import { INDUCTION_QUOTE_KEY } from "./useInductionQuote";

// After a batch is submitted: what the rest of Protect shows is out of date.
export function useInvalidateInduction() {
  const trpc = useProtectTRPC();
  const queryClient = useQueryClient();

  return () => {
    queryClient.removeQueries({ queryKey: INDUCTION_QUOTE_KEY });
    return Promise.all([
      queryClient.invalidateQueries({
        queryKey: trpc.screenings.list.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.list.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.contracts.search.queryKey(),
      }),
      queryClient.invalidateQueries({
        queryKey: trpc.induction.summary.queryKey(),
      }),
      // Stale, but not refetched now: the wizard is the only reader and it
      // refetches on its next mount.
      queryClient.invalidateQueries({
        queryKey: trpc.induction.listPreApproved.queryKey(),
        refetchType: "none",
      }),
    ]);
  };
}
